(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/helpers/swedbank-express-url-helper.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/helpers/swedbank-express-url-helper.js');

'use strict';

const logger = svs.accountservicesReact.deposit.swedbankExpress.logger;

const updateQuerystringWithParamAndValue = (param, value) => {
  svs.utils.url.refreshQueryString();
  let targetPath = svs.utils.url.currentPathEncodedParams();
  targetPath = svs.utils.url.updateQueryStringParameter(targetPath, param, value);
  window.history.replaceState({}, '', targetPath);
};

const getRedirectUrl = _ref => {
  let _ref$authorizeId = _ref.authorizeId,
    authorizeId = _ref$authorizeId === void 0 ? '' : _ref$authorizeId,
    _ref$paymentId = _ref.paymentId,
    paymentId = _ref$paymentId === void 0 ? '' : _ref$paymentId,
    _ref$returnUrl = _ref.returnUrl,
    returnUrl = _ref$returnUrl === void 0 ? '' : _ref$returnUrl;
  let redirectUrl;
  const userAgentFamily = navigator.userAgent.toLowerCase();
  const isNativeApp = svs.core.config.data.svsconfig.isNativeApp;

  if (returnUrl.length > 1) {
    updateQuerystringWithParamAndValue('returnUrl', encodeURIComponent(returnUrl));
  }
  if (authorizeId && authorizeId.length > 2) {
    updateQuerystringWithParamAndValue('aid', authorizeId);
  }
  if (paymentId && paymentId.length > 2) {
    updateQuerystringWithParamAndValue('pid', paymentId);
  }
  if (svs.core.detect.browser.crios()) {
    if (window.location.protocol.indexOf('s') > -1) {
      redirectUrl = 'googlechromes://';
    } else {
      redirectUrl = 'googlechrome://';
    }
  } else if (svs.core.detect.os.iOS()) {
    if (isNativeApp) {
      redirectUrl = encodeURIComponent(window.location.href.replace(/https?/i, 'spelbutiken.bankid'));
    } else if (userAgentFamily.indexOf('firefox') > -1) {
      redirectUrl = encodeURIComponent("firefox://open-url?url=".concat(svs.utils.url.currentUrlEncodedParams()));
    } else if (userAgentFamily.indexOf('safari') > -1) {
      redirectUrl = encodeURIComponent(svs.utils.url.currentUrlEncodedParams());
    } else {
      redirectUrl = 'null'; 
    }
  } else {
    redirectUrl = 'null';
  }
  logger.debug("Bankid return url: ".concat(redirectUrl));
  return redirectUrl;
};

const getBankIdAppUrl = _ref2 => {
  let autoStartToken = _ref2.autoStartToken,
    authorizeId = _ref2.authorizeId,
    paymentId = _ref2.paymentId,
    returnUrl = _ref2.returnUrl;
  let url;
  const isNativeApp = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp', window) && svs.core.config.data.svsconfig.isNativeApp;
  if (svs.core.detect.os.iOS() && !isNativeApp) {
    url = "https://app.bankid.com/?autostarttoken=".concat(autoStartToken, "&redirect=").concat(getRedirectUrl({
      authorizeId,
      paymentId,
      returnUrl
    }));
  } else if (svs.core.detect.formfactor.desktop()) {
    url = "bankid:///?autostarttoken=".concat(autoStartToken, "&redirect=null");
  } else {
    url = "bankid:///?autostarttoken=".concat(autoStartToken, "&redirect=").concat(getRedirectUrl({
      authorizeId,
      paymentId,
      returnUrl
    }));
  }
  logger.debug("Bankid start url: ".concat(url));
  return url;
};

const clearUrlParam = paramToClear => {
  logger.debug("clearUrlParam: ".concat(paramToClear));
  svs.utils.url.refreshQueryString();
  const currentParamToClear = svs.utils.url.queryString[paramToClear];
  if (currentParamToClear) {
    let targetString = '';
    let delim = '?';
    for (const param in svs.utils.url.queryString) {
      if (param !== paramToClear) {
        targetString = "".concat(targetString).concat(delim).concat(param, "=").concat(encodeURIComponent(svs.utils.url.queryString[param]));
        delim = '&';
      }
    }
    window.history.replaceState({}, '', "".concat(window.location.pathname).concat(targetString));
    svs.utils.url.refreshQueryString();
  }
};
svs.accountservicesReact.deposit.helpers.swedbankExpressUrlHelper = {
  getBankIdAppUrl,
  clearUrlParam
};

 })(window);